import React from "react";
import PropTypes from "prop-types";

import { useConditionController } from "../../hooks";
import { Button, ConditionRenderer, Dropdown, Icon } from "..";

export function Condition({
  disabled,
  condition,
  hideOperatorAction,
  hideRemoveIcon,
  onAdd,
  onRemove,
  conditionTypes,
}) {
  const { conditionProps, conditionType, parameters } = useConditionController(
    condition,
    conditionTypes
  );

  return (
    <div data-test="condition">
      <div style={{ width: 67, textAlign: "right", paddingRight: 16 }}>
        <b data-test="operator">{condition.operator}</b>
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ width: 67 }} />
        <div style={{ width: 200, marginRight: 16 }}>
          <Dropdown
            disableClearable
            includeInputInList
            data-test="condition-dropdown"
            placeholder="Select field type"
            disabled={disabled}
            {...conditionProps}
          />
        </div>
        <div style={{ flexGrow: 1, display: "flex" }}>
          <ConditionRenderer
            {...condition}
            id={`${condition.id}.condition`}
            disabled={disabled}
            type={conditionType}
            parameters={parameters}
          />
          {!hideRemoveIcon && (
            <Icon
              data-test="delete-condition"
              link
              name="remove"
              size="large"
              color="grey"
              style={{ marginLeft: 16, marginTop: 8 }}
              disabled={disabled}
              onClick={onRemove}
            />
          )}
          {!hideOperatorAction && (
            <div style={{ marginLeft: 16 }}>
              <Button.Group basic>
                <Button
                  data-test="group-and-button"
                  type="button"
                  disabled={disabled}
                  onClick={() => {
                    onAdd("AND");
                  }}
                >
                  AND
                </Button>
              </Button.Group>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

Condition.propTypes = {
  condition: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    operator: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.bool,
  hideOperatorAction: PropTypes.bool,
  hideRemoveIcon: PropTypes.bool,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  conditionTypes: PropTypes.array.isRequired,
};

Condition.defaultProps = {
  disabled: false,
  hideOperatorAction: false,
  hideRemoveIcon: false,
};

export default Condition;
